import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query condicionVenta {
            TYPES {
              CondicionVenta {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => result.data.data.TYPES.CondicionVenta.readAll),
};
